import PropTypes from 'prop-types';
import React from 'react';
import {DonorProfileHeader} from "./DonorProfileHeader.js";
import {ProjectsInProgress} from "./ProjectsInProgress.js";
import {SupportedSubjects} from "./SupportedSubjects.js";
import {FundedProjects} from "./FundedProjects.js";
import {GivingPages} from "./GivingPages.js";
import {ProjectRecommendations} from "./ProjectRecommendations.js"
import {ShareLightBox} from "../common/ShareLightBox.js";
import {loadingStatuses} from "./donorProfileConstants.js";
import { FeatureShutOffMessage } from '../common/FeatureShutOffMessage.js';
import { LoadingEllipsis } from '../common/LoadingEllipsis.js';

export class DonorProfile extends React.PureComponent {
	constructor(props, context) {
		super(props, context);

		this.showShareLightBox = this.showShareLightBox.bind(this);
		this.hideShareLightBox = this.hideShareLightBox.bind(this);
	}

	renderGivingHistory(){
//		we don't expect to ever direct partners to these pages, so we don't bother loading these sections
		if (this.props.donorData.isPartnerPage) {
			return;
		}
		if(!this.props.donorData.givingHistoryEnabled){
			return <FeatureShutOffMessage />;
		}
		return (
			<div>
				{this.renderProjectsInProgress()}
				{this.renderFundedProjects()}
			</div>
		)
	}

	renderProjectsInProgress() {
		if(!this.props.loadingStatuses[loadingStatuses.LOADING_IN_PROGRESS_DONATIONS] && this.props.projectsInProgressDonations.length > 0){
			return <ProjectsInProgress
					displayName={this.props.donorData.displayName}
					projectsInProgress={this.props.projectsInProgress}
					projectsInProgressDonations={this.props.projectsInProgressDonations}
					viewingOwnPage={this.props.viewingOwnPage}
					loadingInProgressProjects={this.props.loadingStatuses[loadingStatuses.LOADING_IN_PROGRESS_PROJECTS]}
					doantionsEndReached={this.props.loadingStatuses[loadingStatuses.IN_PROGRESS_END_REACHED]}
					showMoreProjectsInProgress = {this.props.showMoreProjectsInProgress}
			/>;
		}else if (this.props.loadingStatuses[loadingStatuses.LOADING_IN_PROGRESS_DONATIONS]) {
			return <LoadingEllipsis />;
		}
	}

	renderFundedProjects(){
		if(!this.props.loadingStatuses[loadingStatuses.LOADING_FULLY_FUNDED_DONATIONS] && this.props.fundedProjectDonations.length > 0){
			return <FundedProjects
					displayName={this.props.donorData.displayName}
					numTeachersSupported={this.props.donorData.numTeachersSupported}
					fundedProjects={this.props.fundedProjects}
					fundedProjectDonations={this.props.fundedProjectDonations}
					viewingOwnPage={this.props.viewingOwnPage}
					showMoreFundedProjects = {this.props.showMoreFundedProjects}
					loadingFullyFundedProjects={this.props.loadingStatuses[loadingStatuses.LOADING_FULLY_FUNDED_PROJECTS]}
					doantionsEndReached={this.props.loadingStatuses[loadingStatuses.FULLY_FUNDED_END_REACHED]}
			/>
		}else if (this.props.loadingStatuses[loadingStatuses.LOADING_FULLY_FUNDED_DONATIONS]) {
				return <LoadingEllipsis />;
		}
	}

	renderSupportedSubjects(){
		if(!this.props.donorData.isPartnerPage){
			return <SupportedSubjects
					supportedSubjects={this.props.donorData.supportedSubjects}
					displayName={this.props.donorData.displayName}
					viewingOwnPage={this.props.viewingOwnPage}
			/>
		}
	}

	renderWaysToGiveBanner(){
		const hiPoCart = $('.cart-group .mini-cart').data('value');
		const wtgConditions = userObj.isTTD === true || userObj.isVIP === true || hiPoCart >= 3;
		if(this.props.viewingOwnPage && wtgConditions){
			return <section className="wtg-banner">

				<div className="container">
					<div className="image" role="img" aria-label="icons of different options for giving"></div>
					<div className="inside-container">
						<h3>There are plenty of ways you can support your favorite classrooms.</h3>
						<p>From Donor-advised funds, donating a stock or using cryptocurrency, you have great options.</p>
						<a href={baseURL + '../about/ways-to-give.html'} className="button-secondary">See what works for you</a>
					</div>
				</div>

			</section>
		}

	}

	renderShareLightBox(){
		if(this.props.showShareLightBox){
			let twitterText = this.props.viewingOwnPage ? "I'm proud to support teachers on @DonorsChoose. Check out the learning we can make possible!" : "Check out the learning we can make possible by supporting teachers on @DonorsChoose!"
			return <ShareLightBox
					hideShareLightBox={this.hideShareLightBox}
					pageTitle = {this.props.donorData.pageName}
					urlToShare = {window.location.href}
					pageName = "donorpage"
					twitterText={twitterText}
			/>;
		}
	}

	renderGivingPages(){
		if(this.props.viewingOwnPage && this.props.donorData.hasGivingPages){
			return <GivingPages/>
		}
	}

	showShareLightBox(){
		this.props.setShowShareLightBox(true);
	}

	hideShareLightBox(){
		this.props.setShowShareLightBox(false);
	}

	render() {
		let props = this.props;
		return (
				<div className="donor-profile-page">
					<DonorProfileHeader
							displayName={props.donorData.displayName}
							numProjectsSupported={props.donorData.numProjectsSupported}
							location={props.donorData.location}
							yearJoined={props.donorData.yearJoined}
							favoriteSubject={props.donorData.favoriteSubject}
							favoriteState={props.donorData.favoriteState}
							photoURL={props.donorData.photoURL}
							showShareLightBox={this.showShareLightBox}
					/>
					{this.renderShareLightBox()}
					{this.renderGivingHistory()}
					{this.renderSupportedSubjects()}
					{this.renderWaysToGiveBanner()}
					{this.renderGivingPages()}
					<ProjectRecommendations
							viewingOwnPage={props.viewingOwnPage}
					/>
				</div>
		);
	}
}

DonorProfile.propTypes = {
	donorData: PropTypes.object.isRequired,
	projectsInProgressDonations: PropTypes.array,
	projectsInProgress: PropTypes.array,
	fundedProjectDonations: PropTypes.array,
	fundedProjects: PropTypes.array,
	viewingOwnPage: PropTypes.bool.isRequired,
	loadingStatuses: PropTypes.object.isRequired,
	showShareLightBox: PropTypes.bool.isRequired,
	showMoreFundedProjects: PropTypes.func.isRequired,
	showMoreProjectsInProgress: PropTypes.func.isRequired,
	setShowShareLightBox:PropTypes.func.isRequired
};
